angular.module('SpidApp')

.controller('BusinessDayController',
		['Cash', '$scope', 'BusinessDayService', 'ConfigService', 'Sale', 'VacationService', 'BusinessDay', 'AgencyService', 'VacationDecorator', 'SaleService', '$q', 'TransactionService', 'UserService', '$timeout', 'Toaster',
function (Cash,   $scope,   BusinessDayService,   ConfigService,   Sale,   VacationService,   BusinessDay,   AgencyService,   VacationDecorator,   SaleService,   $q,   TransactionService,   UserService,   $timeout,   Toaster) {
	
	var date    =  moment()
	var isoDate = date.toISOString().substr(0, 10)
	
	$scope.todayDate  	= date.format('LL');
	$scope.currentDate  = date.format('LL');
	$scope.currentAmount = 0;
	
	var loadBusinessDay = function(isoDate) {
		ConfigService.all().then(function (config) {
			$scope.agencyId = config.agencyId;

			AgencyService.find(config.agencyId).then(function (agency) {
				$scope.agency = agency;

				var mapF = function (e) { return { value: e, quantity: 0 } }
				$scope.coins = agency.currency.coins.map(mapF)
				$scope.bills = agency.currency.bills.map(mapF)

				BusinessDayService.getByAgencyIdAndByDate(config.agencyId, isoDate).then(function (businessDay) {
					$scope.businessDay = businessDay
				
				}, function (error) {
					$scope.businessDay = new BusinessDay() 
					if (error.status === 404) {
						$scope.businessDay = new BusinessDay({
							agency_id: agency.id
						})
					} else {
						console.error('We should be worried')
					}
					
				}).finally(function () {
					
					$scope.validateBusinessDay = function (businessDay) {
						businessDay.setValidated();
						businessDay.date = isoDate;
						businessDay.cash = Cash.deno($scope.bills, $scope.coins);
						businessDay.sum = $scope.sum;

						BusinessDayService.save(agency.id, businessDay).then(function () {
							businessDay.setValidated()
							Toaster.show('La journée a été validée')
						}, function () {
							businessDay.setUnvalidated()
						})
					}
				})
			})
			
			UserService.all().then(function(users) {
				VacationService.findByAgencyId(config.agencyId, { filter: { date: isoDate } }).then(function (vacations) {
					var p = []
					
					$scope.vacations = _.chain(vacations).map(function (vacation) {
						var vacationDecorator = VacationDecorator(vacation);
						
						var user = _.find(users, function(user) {
	    	    	    	return user.id === vacationDecorator.idUser;
	        	    	});
	    	    		if (user) {
	    	    			vacationDecorator.userFirstname = user.firstname;
	    	    			vacationDecorator.userLastname  = user.lastname;
	    	    			vacationDecorator.username  = user.username;
	    	    		}
						
						return vacationDecorator;
						
					}).each(function (vacation) {
						var pp = SaleService.findByVacationId(config.agencyId, vacation.id).then(function (sales) {
							var pool = []
							sales.forEach(function (sale) {
								var p = TransactionService.find(config.agencyId, sale.transactionId).then(function (transaction) {
									sale.transaction = transaction
									return sale
								})
	
								pool.push(p)
							})
	
							return $q.all(pool)
						}).then(function (sales) {
							
							return _.chain(sales).filter(function (sale) {
								return sale.transaction.finished
							}).value()
							
						}).then(function (sales) {
							vacation.sales = sales
							vacation.totalSalePrice = Sale.totalPrice(sales)
							vacation.isBalanced = vacation.amountStart + vacation.startTransfer + vacation.totalSalePrice === +vacation.amountStop
						})
						
						p.push(pp)
					}).value()
					
					return $q.all(p).then(function () {
						
						$scope.businessDayIsValidable = _.reduce(vacations, function (memo, vacation) {
							return memo && vacation.isValidated()
						}, true)
					})
				})
			})
		})
	}
	loadBusinessDay(isoDate);
	
	$scope.changeDate = function(step) {
		if (!step) {
			date = moment();
		} else if (step === -1) {
			date = date.subtract(1, 'days');
		} else {
			date = date.add(1, 'days');
		}
		var isoDate 	    = date.toISOString().substr(0, 10)
		$scope.currentDate  = date.format('LL');
		
		loadBusinessDay(isoDate);
	}
	
	$scope.printDay = function() {
		$scope.dateNow = moment(new Date()).format('LLL');
		
    	$timeout(function() {
    		window.print();
    	}, 50);
	}

	$scope.sum = 0;
	$scope.updateSum = function(){
		$scope.sum = Cash.cumulate($scope.coins,$scope.bills);
	};


	
	window.scope = $scope
}])